import { useMemo } from "react";
import { MapContainer, TileLayer, Circle, Popup } from "react-leaflet";
import "leaflet/dist/leaflet.css";

const MAP_STYLE = { height: "300px", width: "100%", contain: "layout paint" };

export default function DetailMap({ lat, lng, name }) {
  const position = useMemo(() => [lat, lng], [lat, lng]);

  if (lat == null || lng == null) return null;

  return (
    <div data-testid="detail-map" className="min-w-0 max-w-full rounded-2xl overflow-hidden border border-black/5">
      <MapContainer
        center={position}
        zoom={15}
        style={MAP_STYLE}
        scrollWheelZoom={false}
        zoomControl={true}
        dragging={true}
      >
        <TileLayer
          attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a>'
          url="https://{s}.basemaps.cartocdn.com/light_all/{z}/{x}/{y}{r}.png"
        />
        <Circle
          center={position}
          radius={250}
          pathOptions={{ color: "#1D1D1F", fillColor: "#86868B", fillOpacity: 0.18, weight: 2 }}
          eventHandlers={{ add: ({ target }) => target.getElement()?.setAttribute("data-testid", "detail-map-area") }}
        >
          <Popup>
            <span data-testid="detail-map-area-name" style={{ fontFamily: "'Outfit', sans-serif", fontWeight: 600, fontSize: "14px" }}>
              {name}
            </span>
          </Popup>
        </Circle>
      </MapContainer>
    </div>
  );
}
